import { Project } from '~/common/entities/Project/ProjectTypes';
import { HStack, Link, Text, Box } from '@chakra-ui/react';
import routes from '~/common/constants/routes.json';
import useTranslate from '~/common/utils/translate';
import React, { useRef, useEffect } from 'react';
import { css } from '@emotion/react';
import _ from 'lodash';

interface ScrollableOptionsProps {
  project: Project;
  projects: Project[];
}

const ScrollableOptions: React.FC<ScrollableOptionsProps> = ({
  project,
  projects,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const translate = useTranslate();
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (scrollContainerRef.current) {
        if (e.deltaY !== 0) {
          scrollContainerRef.current.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }
    };

    const container = scrollContainerRef.current;
    container?.addEventListener('wheel', handleWheel);

    return () => {
      container?.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <Box>
      <HStack spacing={1} overflow="hidden">
        <Text fontWeight="semibold">{translate('project.options')}</Text>
        <Box
          ref={scrollContainerRef}
          css={css`
            max-width: 100%;
            overflow-x: auto;
            white-space: nowrap;
            &::-webkit-scrollbar {
              height: 6px;
            }
            &::-webkit-scrollbar-thumb {
              background-color: grey;
              border-radius: 300px;
            }
            &::-webkit-scrollbar-thumb:hover {
              background-color: #333;
            }
            &::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 10px;
            }
          `}
          ml={2}
        >
          <HStack spacing={4}>
            {_.sortBy(projects, ['name'], 'asc').map(
              (p, index) =>
                project.option_ids.find((id: any) => id === p.id) && (
                  <HStack key={p.id}>
                    <Link
                      href={'#' + routes.PROJECT.replace(':id', String(p.id))}
                    >
                      {p.name}
                      {index < (projects?.length ?? 0) - 1}
                    </Link>
                  </HStack>
                ),
            )}
          </HStack>
        </Box>
      </HStack>
    </Box>
  );
};

export default ScrollableOptions;
